<template>
  <div class="bb-tabbar-wrap">
    <div class="bb-trade-mask" v-if="tradeOpen" @click="tradeOpen = false"></div>
    <div class="bb-tabbar" role="tablist">
      <div
        v-for="(item, index) in navList"
        :key="index"
        class="bb-tab-cell"
      >
        <button
          class="bb-tab"
          :class="{ active: isTabActive(item) }"
          type="button"
          role="tab"
          @click="onTab(item)"
        >
          <div class="bb-tab-icon" v-html="isTabActive(item) ? item.iconOn : item.iconOff"></div>
          <p>{{ item.name }}</p>
        </button>
        <div class="bb-trade-pop" v-if="item.pick && tradeOpen">
          <button
            v-for="opt in tradeChoices"
            :key="opt.path"
            type="button"
            class="bb-trade-opt"
            :class="{ active: $route.path === opt.path }"
            @click="goTrade(opt.path)"
          >
            {{ opt.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      tradeOpen: false
    };
  },
  computed: {
    ...mapState(["footerWhiteList"]),
    navList() {
      return [
        {
          name: this.$t("navTab.tabMenu1"),
          path: "/",
          iconOn: this.iconHome(true),
          iconOff: this.iconHome(false)
        },
        {
          name: this.$t("navTab.tabMenu2"),
          path: "/market",
          iconOn: this.iconMarket(true),
          iconOff: this.iconMarket(false)
        },
        {
          name: this.$t("navTab.trade"),
          path: "/trade",
          pick: true,
          iconOn: this.iconTrade(true),
          iconOff: this.iconTrade(false)
        },
        {
          name: this.$t("navTab.tabMenu3"),
          path: "/trading",
          iconOn: this.iconLoan(true),
          iconOff: this.iconLoan(false)
        },
        {
          name: this.$t("navTab.tabMenu7"),
          path: "/profile",
          iconOn: this.iconAsset(true),
          iconOff: this.iconAsset(false)
        }
      ];
    },
    tradeChoices() {
      return [
        { name: this.$t("Market.options"), path: "/trade/options" },
        { name: this.$t("Market.contracts"), path: "/trade/futures" }
      ];
    },
    currentPath() {
      return "/" + this.$route.path.split("/")[1];
    }
  },
  methods: {
    iconHome() {
      return `<svg class="size-full" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.91342 2H4.33097C4.02107 2 3.77002 2.25115 3.77002 2.56115V7.32122C3.77002 7.63122 4.02107 7.88237 4.33097 7.88237H8.47437V2.56115C8.47437 2.25115 8.22331 2 7.91342 2Z" fill="#F68F15"></path><path d="M8.47437 7.88237L8.47439 12.0272C8.47439 12.3372 8.72545 12.5884 9.03534 12.5884H13.1987C14.4977 12.5884 15.5508 13.6418 15.5508 14.9413C15.5508 16.2407 14.4977 17.2942 13.1987 17.2942H9.65027C9.00078 17.2942 8.47439 16.7676 8.47411 16.1179V13.1493C8.47411 12.8392 8.22305 12.5881 7.91316 12.5881H4.33099C4.0211 12.5881 3.77005 12.8392 3.77005 13.1493V16.7327C3.77005 17.0427 4.0211 17.2939 4.33099 17.2939H7.29824C7.94772 17.2939 8.47439 17.8207 8.47439 18.4705V21.4388C8.47439 21.7488 8.72545 21.9999 9.03534 21.9999H12.9183C16.9703 21.9999 20.2551 18.7139 20.2551 14.6604C20.2551 10.9169 17.2213 7.88203 13.4792 7.88203L8.47437 7.88237Z" fill="currentColor"></path></svg>`;
    },
    iconMarket() {
      return `<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 3C21.3284 3 22 3.67157 22 4.5V19.5C22 20.3284 21.3284 21 20.5 21H3.5C2.67157 21 2 20.3284 2 19.5L2 4.5C2 3.67157 2.67157 3 3.5 3L20.5 3ZM13.5508 8.76172C13.3798 8.76874 13.2962 8.97368 13.4131 9.09863L14.3555 10.1055C14.4292 10.1842 14.4269 10.3075 14.3506 10.3838L12.5068 12.2275C12.4287 12.3056 12.3017 12.3056 12.2236 12.2275L9.86621 9.87012C9.67094 9.67488 9.35443 9.67486 9.15918 9.87012L5.33691 13.6924C5.14178 13.8876 5.14194 14.2041 5.33691 14.3994L6.04395 15.1064C6.23921 15.3017 6.55571 15.3017 6.75098 15.1064L9.37109 12.4863C9.44917 12.4083 9.5762 12.4083 9.6543 12.4863L12.0127 14.8447C12.2079 15.0396 12.5245 15.0397 12.7197 14.8447L18.6621 8.90137C18.7908 8.77258 18.6947 8.55315 18.5127 8.56055L13.5508 8.76172Z" fill="currentColor"></path></svg>`;
    },
    iconTrade() {
      return `<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.32861 4.56543C9.32884 3.73719 10.0003 3.06543 10.8286 3.06543L19.4067 3.06543C20.2349 3.06563 20.9065 3.73732 20.9067 4.56543L20.9067 13.1436C20.9067 13.9719 20.235 14.6434 19.4067 14.6436L14.6714 14.6436L14.6714 9.85742C14.6714 9.58128 14.4475 9.35742 14.1714 9.35742L9.32861 9.35742L9.32861 4.56543ZM3.09326 10.8574C3.09326 10.0291 3.765 9.35762 4.59326 9.35742L9.32861 9.35742L9.32861 14.1436C9.32861 14.4197 9.55247 14.6436 9.82861 14.6436L14.6714 14.6436L14.6714 19.4346C14.6714 20.263 13.9998 20.9346 13.1714 20.9346L4.59326 20.9346C3.765 20.9344 3.09326 20.2629 3.09326 19.4346L3.09326 10.8574Z" fill="currentColor"></path></svg>`;
    },
    iconLoan() {
      return `<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.64616 12.803C9.10845 12.803 9.51082 13.1201 9.61881 13.5696L10.904 18.9211C11.0549 19.5499 10.5788 20.1543 9.93229 20.1545H2.11979C1.47495 20.1545 0.99847 19.5528 1.14616 18.925L2.40495 13.5745C2.51122 13.1228 2.91456 12.803 3.37858 12.803H8.64616ZM20.5924 12.803C21.0547 12.803 21.4571 13.1201 21.5651 13.5696L22.8512 18.9211C23.0021 19.5499 22.5253 20.1545 21.8786 20.1545H14.0661C13.4213 20.1545 12.9448 19.5527 13.0924 18.925L14.3522 13.5745C14.4585 13.1229 14.861 12.8032 15.3249 12.803H20.5924ZM14.6501 3.84692C15.1122 3.84706 15.5138 4.16412 15.6217 4.61353L16.9079 9.96509C17.0588 10.5939 16.5819 11.1985 15.9352 11.1985H8.12272C7.47808 11.1982 7.00241 10.5966 7.15006 9.96899L8.40885 4.61841C8.51514 4.16669 8.91843 3.84692 9.38249 3.84692H14.6501Z" fill="currentColor"></path></svg>`;
    },
    iconAsset() {
      return `<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 6.5C21.3284 6.5 22 7.17157 22 8V19C22 19.8284 21.3284 20.5 20.5 20.5H3.5C2.67157 20.5 2 19.8284 2 19V6.5H20.5ZM16 11.5C15.7239 11.5 15.5 11.7239 15.5 12V13C15.5 13.2761 15.7239 13.5 16 13.5H19C19.2761 13.5 19.5 13.2761 19.5 13V12C19.5 11.7239 19.2761 11.5 19 11.5H16Z" fill="currentColor"></path><path d="M14.5 3.5C15.3284 3.5 16 4.17157 16 5H2C2 4.17157 2.67157 3.5 3.5 3.5H14.5Z" fill="currentColor"></path></svg>`;
    },
    isTabActive(item) {
      if (item.path === "/trade") {
        return this.$route.path.startsWith("/trade/");
      }
      if (item.path === "/profile") {
        return this.$route.path === "/profile";
      }
      return this.currentPath === item.path;
    },
    onTab(item) {
      if (item.pick) {
        this.tradeOpen = !this.tradeOpen;
        return;
      }
      this.tradeOpen = false;
      this.gopage(item.path);
    },
    goTrade(url) {
      this.tradeOpen = false;
      this.gopage(url);
    },
    gopage(url) {
      if (this.$route.path === url) {
        return;
      }
      this.$router.push(url).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error("路由跳转错误:", err);
        }
      });
    }
  }
};
</script>
<style scoped>
.bb-tabbar-wrap {
  height: 54px;
}
.bb-tabbar {
  display: flex;
  align-items: flex-start;
  background: var(--bb-bg);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  overflow: visible;
  border-top: 1px solid var(--bb-divider);
  border-radius: 20px 20px 0 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
.bb-tab-cell {
  flex: 1;
  position: relative;
}
.bb-tab {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--bb-text-tertiary);
  padding: 10px 0 6px;
}
.bb-tab.active {
  color: var(--bb-text);
}
.bb-tab-icon {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}
.bb-tab.active .bb-tab-icon {
  opacity: 1;
}
.bb-tab p {
  margin: 0;
  font-size: 10px;
  line-height: 14px;
  font-weight: 400;
  white-space: nowrap;
}
.bb-tab-icon >>> svg {
  width: 24px;
  height: 24px;
  display: block;
}
.bb-trade-mask {
  position: fixed;
  inset: 0;
  z-index: 19;
  background: transparent;
}
.bb-trade-pop {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  z-index: 21;
  min-width: 112px;
  padding: 6px 0;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 12px;
  box-shadow: var(--bb-shadow);
}
.bb-trade-pop::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  width: 10px;
  height: 10px;
  background: var(--bb-bg-elevated);
  border-right: 1px solid var(--bb-border);
  border-bottom: 1px solid var(--bb-border);
  transform: translateX(-50%) rotate(45deg);
}
.bb-trade-opt {
  display: block;
  width: 100%;
  height: 40px;
  padding: 0 18px;
  border: 0;
  background: transparent;
  color: var(--bb-text);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}
.bb-trade-opt.active {
  color: var(--bb-brand);
  font-weight: 600;
}
</style>
